import { useEffect, useState } from 'react';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';

interface Props {
    track: string;
    index: number;
    setAllIndex: any;
    allIndex: number[];
}

const AudioPlayers = (props: Props) => {

    const [playing, setIsPlaying] = useState(false);
    const [htmlElem, sethtmlElem] = useState() as any;
    const { index, setAllIndex, allIndex } = props;
    const checkIndex = allIndex.some((elem: any) => elem === index)
    const [customClass, setCustomClass] = useState("")
    useEffect(() => {
        setCustomClass("audio-Player")
    }, [])

    useEffect(() => {

        var audios = document.getElementsByTagName('audio');
        for (var i = 0, len = audios.length; i < len; i++) {
            if (audios[i] !== htmlElem) {
                audios[i].pause();              
            }
        }

    }, [playing, htmlElem])


    const handleOnplay = (e: any) => {
      
        setCustomClass("audio-playing")
        sethtmlElem(e.target)
        setAllIndex((prev: any) => [...prev, index])
        setIsPlaying(!playing)
       

    }
    const handleplay = (e: any) => {
        setCustomClass("audio-playing")
        sethtmlElem(e.target)
        setIsPlaying(!playing)
        

    }
    
    
    return (
        <div className={customClass} data-testid='audio-Player'>
            <AudioPlayer
                autoPlay={false}
                src={props?.track}
                onPlay={e => {
                    checkIndex ?
                        handleplay(e)
                        :
                        handleOnplay(e)
                }}
            />
        </div >
    )
}

export default AudioPlayers;